import { Dialog } from '@headlessui/react';

const DialogPanel = ({ children }) => {
  return (
    <Dialog.Panel className="tw-relative tw-bg-gradient-to-b tw-from-[#283859] tw-to-[#0f1b2d] tw-rounded-lg small:tw-mx-1 medium-up:tw-mx-auto tw-flex tw-flex-col tw-items-center small:tw-py-8 small:tw-px-6 medium-up:tw-p-24 tw-max-w-6xl">
      {children}
    </Dialog.Panel>
  );
};

export default DialogPanel;
